const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBostderBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "bostader",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234.14 231.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "e4b335a7-fd75-420b-ae71-5da7ab263ce0",
    "data-name": "border",
    d: "M86.8.27l44.57,16.54V30l25.55-12.12L189.52,34l-.13,18.63,18.88-8.53L233.88,58.5,229.63,189l-18.15-.5-.25,24.63-96.88.2s-.38,9.39-6.31,12.84c-5.67,3.31-26.41,6.64-44.92,4.88s-20.73-16.28-20.73-16.28L.25,214.27V120.06L41.82,74.38l4.74-.24.92-58.61Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBostderBorder);
export default __webpack_public_path__ + "static/media/bostäder-border.4276cc501485dac9aaa451c9df7b1b9d.svg";
export { ForwardRef as ReactComponent };